import { CALL_API_SEQUENCED } from '../app/apiMiddlewareSequenced';
import { Microservices } from '../app/AllowedMicroservices';
import { PayloadAction, ActionCreatorWithPayload, ActionCreatorWithoutPayload } from '@reduxjs/toolkit';
import { Dispatch } from 'react';

interface SelectorFun<T,TResult>
{
    (item: T): TResult;
}

interface GeneralAction {
  type: string,
  payload: any
}
type ApiActionCreatorType = (dispatch: Dispatch<object>) => void;

interface ActionWithSelector {
  actionOrCreator: ApiActionCreatorType | ActionCreatorWithPayload<any> | ActionCreatorWithoutPayload | GeneralAction,
  selector?: SelectorFun<object, any>
}

interface FuncPayload
{
    (K: any): PayloadAction;
}

interface Types{
  requestType: PayloadAction | FuncPayload | GeneralAction,
  successTypes: ActionWithSelector[],
  errorTypes: ActionWithSelector[],
}

export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

// Same shape/behavior as apiActionCreator, plus `sequenceKey`: calls that
// share a key compete with each other, and only the response to the most
// recently *dispatched* call for that key gets to run its success/error
// actions (see apiMiddlewareSequenced.ts). Defaults to `endpoint`. Use this
// instead of apiActionCreator only for calls where an older response
// landing after a newer one would silently overwrite fresher state with
// stale data (SYSTEM.debt.md §15.29) - not a general-purpose replacement.
const ApiActionCreatorSequenced = ({
  endpoint,
  types,
  method,
  microservice,
  authenticated = false,
  data,
  contentType,
  customToken,
  sequenceKey,
}: {
  endpoint: string,
  types: Types,
  method: HttpMethods,
  microservice: Microservices,
  authenticated?: boolean,
  data?: any,
  contentType?: string,
  customToken?: string,
  sequenceKey?: string,
}) => {
  return {
    [CALL_API_SEQUENCED]: {
      endpoint,
      types,
      method,
      microservice,
      authenticated,
      data,
      contentType,
      customToken,
      sequenceKey,
    },
  };
};

export default ApiActionCreatorSequenced;
